import React from 'react';
import { observer } from 'mobx-react'

import { styled } from "../../stitches.config"
import AuthorBlock from '../AuthorBlock';
//import SocialButton from "../atoms/SocialButton"
import SocialButtonLike from "../atoms/SocialButtonLike"
import SocialButtonComment from "../atoms/SocialButtonComment"
import SocialButtonShare from "../atoms/SocialButtonShare"
import { useStores, pushDataLayer } from "../../helpers"

import { IS_FEATURE_enableComments } from "../../components/common/constants/constants";
interface AuthorDateProps {
    article: ArticleAuthor;
}

const AuthorDate: React.FC<AuthorDateProps> = observer(({
    article
}) => {
    const { ArticleStore } = useStores();
    const url = ArticleStore.article.fb_url;

    return (
        <StyledAuthorDate className="author-date">
            <Wrapper>
                <AuthorBlock
                    author={article.author}
                    border={true}
                    articleDate={article.date}
                    articleUpdateDate={article.update_date}
                    articleReadingTime={article.reading_time}
                    starButton
                />
            </Wrapper>
            <Stats>
                <SocialButtonLike url={url} />
                {IS_FEATURE_enableComments && <SocialButtonComment />}
                <SocialButtonShare url={url} />
            </Stats>
        </StyledAuthorDate>
    );
});

const StyledAuthorDate = styled('div', {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "24px",
    "@bp4": {
        marginBottom: "40px",
    }
})

const Stats = styled('div', {
    display: "none",
    "@bp4": {
        display: "flex",
    }
})

const Wrapper = styled('div', {
    "& .avatar": {
        width: "72px",
        height: "72px",
        borderRadius: "72px",
        marginRight: "20px !important",
    },
    "& p": {
        margin: "0 0 4px 0 !important",
    },
})

export default AuthorDate